const TextInput = ({ onChange, value, style, placeholder }) => {
  return (
    <input
      style={{
        outline: "none",
        margin: "0",
        shadow: "none",
        border: "none",
        overflowX: "hidden",
        paddingLeft: 5,
        fontSize: 12,
        ...style,
      }}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
    />
  );
};

export default TextInput;
